export default __webpack_public_path__ + "static/media/s9.a00f1631.jpeg";